const textStyles = {
    eyeBrowLarge: {
        fontSize: 'xl',
        fontFamily: 'body',
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: '0.01em'
    },
    eyeBrowSmall: {
        fontSize: 'md',
        fontFamily: 'body',
        fontWeight: 500,
        lineHeight: 'shorter',
        letterSpacing: '0.01em'
    },
    bodyLarge1: {
        fontSize: 'lg',
        fontFamily: 'body',
        fontWeight: 500,
        lineHeight: 'short',
        letterSpacing: '0.01em'
    },
    bodyLarge2: {
        fontSize: 'lg',
        fontWeight: 400,
        lineHeight: 'short',
        letterSpacing: '0.01em'
    },
    bodyBase1: {
        fontSize: 'md',
        fontFamily: 'body',
        fontWeight: 500,
        lineHeight: 'short',
        letterSpacing: '0.01em'
    },
    bodyBase2: {
        fontSize: 'md',
        fontWeight: 400,
        lineHeight: 'short',
        letterSpacing: '0.01em'
    },
    bodyBase3: {
        fontSize: 'md',
        fontWeight: 400,
        lineHeight: 'shorter',
        letterSpacing: '0.01em'
    },
    bodySmall: {
        fontSize: 'sm',
        fontWeight: 400,
        lineHeight: 'short',
        letterSpacing: '0.01em'
    },
    bodyXSmall: {
        fontSize: 'xs',
        fontWeight: 400,
        lineHeight: 'short',
        letterSpacing: '0.04em'
    },
    bodyXSmall2: {
        fontSize: 'xs',
        fontWeight: 'medium',
        lineHeight: 'shorter',
        letterSpacing: '0.06em'
    },
    descriptor: {
        fontSize: 'xs',
        fontFamily: 'body',
        fontWeight: 500,
        lineHeight: 'shorter',
        letterSpacing: '0.06em'
    },
    link: {
        fontSize: 'md',
        fontWeight: 500,
        lineHeight: 'shorter',
        letterSpacing: '0.01em',
        textDecoration: 'underline'
    },
    touchFriendly: {
        fontSize: ['xlplus', 'xlplus', 'md'],
        fontWeight: [500, 500, 400],
        lineHeight: 'short',
        letterSpacing: '0.01em'
    }
}

export default textStyles
